import React, { useState } from 'react';
import { Form, Formik} from 'formik';
import styled from 'styled-components'
import { useDispatch } from 'react-redux';
import {
  getAuthInitialValues,
  VALIDATION_SCHEMA,
} from 'web/components/utils/editPurchasingUtils';

import {
  editPurchasingLimit,
} from 'redux/actions/accountSetting';

import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';

import NumberInput from 'web/components/form-elements/NumberInput';

import CloseIcon from 'web/assets/images/CloseIcon.png';

import { Modal, ModalBody } from 'reactstrap';
import { Container, Body, RecurrencePattern, BoxWrapper, ModalContainer} from './createStyled'

export default ({ isOpen, toggle, link, responseSet, index, callBackFun, pageLanguageContents }) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const [selectedRadio, setSelectedRadio] = useState('LOCATION');
  const [errorMsg, setErrorMsg] = useState();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const toggleModal = () => setModal(!modal);

  const token = localStorage.getItem('token');

  const editPurchasingLimitApi = async (props) => {
    let data = {
      amount: props.values.purchasingLimit,
    }
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(editPurchasingLimit(responseSet.locationId, data, token));
      if (response.status === 'SUCCESS') {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
        setErrorMsg('')
        callBackFun(index)

      } else {
        if (response.statusCode) {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          let msg = response.message ? response.message : "Api failure"
          setErrorMsg(msg)
        }
      }
    }
  }
  return (
    <ModalContainer>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={"static"}
        centered={true}
        fullscreen="fullscreen"
        className="edit-community-name-modal"
      >
        <div className="">
          <div className="header">
            <Button
              handleClick={() => {
                setErrorMsg('')
                setSelectedRadio("LOCATION");
                toggle(!isOpen);
              }}
            >
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>{pageLanguageContents?.Location_Contents[21]?.EditPurchasingLimit}</h3>
          </div>
          <ModalBody>
            <Formik
              initialValues={getAuthInitialValues(
                responseSet.purchasingLimit
              )}
              validationSchema={VALIDATION_SCHEMA}
              onSubmit={(values) => { }}
            >
              {(props) => {
                const {
                  isValid,
                  dirty,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                } = props;
                return (
                  <>
                    <Form>
                      <Container>
                        <Body>
                          <RecurrencePattern>
                            <BoxWrapper style={{ maxWidth: '422px' }}>
                              <NumberInput
                                name="purchasingLimit"
                                placeholder={pageLanguageContents?.Location_Contents[19]?.PurchasingLimit}
                                maxLength={15}
                              />
                              <p className="error-message">{errorMsg}</p>
                            </BoxWrapper>
                          </RecurrencePattern>
                          <ActionBtn>
                            <Button
                              type="app-green-button"
                              disabled={!(isValid && dirty)}
                              handleClick={() => {
                                editPurchasingLimitApi(props);
                              }}
                            >
                              {pageLanguageContents?.Location_Contents[22]?.Update}
                            </Button>
                          </ActionBtn>
                        </Body>
                      </Container>
                    </Form>
                  </>
                );
              }}
            </Formik>
          </ModalBody>
        </div>
      </Modal>
    </ModalContainer>
  );
};

const ActionBtn = styled.div`
 display: flex;
     margin: 15px 0;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    > button {
      height: 38px;
     min-width: 100px;
     border-radius: 6px;
    }

`
const SearchRadio = styled.div`
    display: flex;
    justify-content: space-evenly;

`